import { render } from "./DashboardInvoiceTab.vue?vue&type=template&id=771b43a3&scoped=true"
import script from "./DashboardInvoiceTab.vue?vue&type=script&lang=js"
export * from "./DashboardInvoiceTab.vue?vue&type=script&lang=js"

import "./DashboardInvoiceTab.vue?vue&type=style&index=0&id=771b43a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771b43a3"]])

export default __exports__